/**
 * `otp` translations, for every locale -- the sign-in card and its
 * admin settings section.
 */
export const otp = {
  mn: {
    otp: {
      orDivider: 'эсвэл',
      signInPrompt: 'Үргэлжлүүлэхийн тулд нэвтэрнэ үү.',
      signInMicrosoft: 'Microsoft-оор нэвтрэх',
      signInMicrosoftWaiting: 'Microsoft-ыг хүлээж байна…',
      signInMicrosoftHint: 'Ажлын бүртгэлээ ашиглана: Teams-д ашигладаг бүртгэл.',
      noAccountTitle: 'CenTrig бүртгэл алга',
      noAccountSwitch: 'Өөр хүнээр нэвтрэх',
      noAccountFallback: 'Microsoft-оор амжилттай нэвтэрсэн ч энэ бүртгэлд CenTrig-ийн хэрэглэгчийн бичлэг алга тул хандах эрх олгогдохгүй. Админаар нэмүүлнэ үү.',
      noAccountInactive: 'Энэ бүртгэл идэвхгүй байна. Алдаа гэж үзвэл HR эсвэл админд хандана уу.',
      demoTitle: 'Хэн болж нэвтрэх вэ',
      demoIntro: 'Энэ бол зохиомол компанитай демо. Үүргээ сонгоод тэр хүний харах зүйлийг үзнэ үү.',
      demoCodeLabel: 'Демо нэвтрэх код',
      demoSigningIn: 'Нэвтэрч байна…',
      demoLoadFailed: 'Демо хэрэглэгчдийг ачаалж чадсангүй',
      demoNone: 'Энэ демод нэвтрэх хэрэглэгч алга. Өгөгдлийг дахин үүсгэнэ үү.',
      demoRole: {
        admin: 'Админ',
        ceo: 'Гүйцэтгэх захирал',
        hr: 'Хүний нөөц',
        accountant: 'Нягтлан бодогч',
        supervisor: 'Ахлах',
        supervisee: 'Ажилтан',
        contractor: 'Гэрээт ажилтан',
        external: 'Гадны ажилтан',
      },
      demoHint: {
        admin: 'Бүх модуль болон админ хуудсууд',
        ceo: 'Батлах, зөвшөөрөх зүйлс',
        hr: 'Хүмүүс, чөлөө, цагийн бүртгэл',
        accountant: 'Борлуулалт, цалин, үйл ажиллагааны сан',
        supervisor: 'Багаа удирдаж, хүсэлтүүдийг батлана',
        supervisee: 'Өөрийн цаг, чөлөө, хуваарь',
        contractor: 'Зөвхөн өөрийн өдрүүд, хуваарь',
        external: 'Гадны компанийн ажилтан: зөвхөн өөрийн хуваарь, өдрүүд',
      },
      methodPassword: 'Нууц үг',
      methodCode: 'И-мэйлээр код авах',
      methodGroup: 'Нэвтрэх арга',
      codeNeedsEmail: 'Кодоор нэвтрэхэд и-мэйл хаяг хэрэгтэй.',
      sendCode: 'Код илгээх',
      sending: 'Илгээж байна…',
      codeStepTitle: 'Кодоо оруулна уу',
      codeLabel: 'Код',
      verify: 'Нэвтрэх',
      verifying: 'Нэвтэрч байна…',
      changeEmail: 'Өөр и-мэйл ашиглах',
      forgotLink: 'Нууц үгээ мартсан уу?',
      forgotIntro: 'Компанийн администратор өөрийн и-мэйлд ирсэн кодоор нууц үгээ шинэчилнэ. Бусад хүмүүс администратортаа хандана уу.',
      forgotSend: 'Надад код илгээх',
      forgotSent: 'Хэрэв энэ нь өмнө нь нэвтэрч байсан администратор бол бид и-мэйлээр код илгээлээ. Ирэхэд нэг минут орчим зарцуулж магадгүй.',
      forgotSave: 'Шинэ нууц үг тохируулах',
      forgotSaving: 'Хадгалж байна…',
      forgotDone: 'Нууц үг солигдлоо. Шинэ нууц үгээрээ нэвтэрнэ үү.',
      forgotBack: 'Нэвтрэх рүү буцах',
      secondStepNotice: 'Бид танд нэвтрэх кодыг и-мэйлээр илгээлээ. Нэвтрэхийн тулд кодоо энд оруулна уу.',
      secondStepRefused: 'Код буруу эсвэл хугацаа нь дууссан байна. Дахин оролдох эсвэл шинэ код авахын тулд эхнээс нь эхэлнэ үү.',
      secondStepNotSent: 'Нууц үг зөв байна, гэхдээ кодыг и-мэйлээр илгээж чадсангүй. Хэдэн минутын дараа дахин оролдоно уу.',
      secondStepTooMany: 'Энэ бүртгэлд хэт олон код илгээгдсэн байна. Нэг цаг хүлээгээд дахин оролдоно уу.',
      startOver: 'Эхнээс нь эхлэх',
      adminSubtitle: 'И-мэйл кодоор нэвтрэх бодлогыг энд тохируулна.',
      settingsTitle: 'Нарийвчилсан тохиргоо',
      enabled: 'И-мэйл кодоор нэвтрэхийг идэвхжүүлэх',
      codeLength: 'Кодын урт',
      codeLengthHint: '4–12 орон',
      ttlSeconds: 'Кодын хүчинтэй хугацаа (секунд)',
      ttlHint: '60–3600 секунд',
      maxAttempts: 'Оролдлогын дээд тоо',
      maxAttemptsHint: '1–10 удаа',
      maxRequestsPerHour: 'Цагт авах кодын дээд тоо',
      maxRequestsPerHourHint: 'Нэг и-мэйл хаягт 1–50',
      allowExternalEmail: 'Гадны и-мэйл хаяг зөвшөөрөх',
      saved: 'Хадгалагдлаа',
      loadFailed: 'Нэвтрэх тохиргоог ачаалж чадсангүй',
      noChanges: 'Өөрчлөлт алга',
      accountNotSetUp:
        'Таны Microsoft бүртгэл ({{address}}) CenTrig-д хараахан тохируулагдаагүй байна: HR эсвэл админаар нэмүүлнэ үү.',
      accountNotSetUpNoAddress:
        'Таны Microsoft бүртгэл CenTrig-д хараахан тохируулагдаагүй байна: HR эсвэл админаар нэмүүлнэ үү.',
    },
  },
  en: {
    otp: {
      orDivider: 'or',
      signInPrompt: 'Sign in to continue.',
      signInMicrosoft: 'Sign in with Microsoft',
      signInMicrosoftWaiting: 'Waiting for Microsoft…',
      signInMicrosoftHint: 'Uses your work account — the same one you use for Teams.',
      noAccountTitle: 'No CenTrig account',
      noAccountSwitch: 'Sign in as someone else',
      noAccountFallback: 'You signed in with Microsoft successfully, but this account has no CenTrig user record, so the API will not grant access. Ask an administrator to add you.',
      noAccountInactive: 'This account is not active. If that is wrong, ask HR or an admin.',
      demoTitle: 'Sign in as',
      demoIntro: 'This is a demo with a made-up company. Pick a role to see what that person sees.',
      demoCodeLabel: 'Demo access code',
      demoSigningIn: 'Signing in…',
      demoLoadFailed: 'Could not load the demo people',
      demoNone: 'This demo has no one to sign in as. Reseed it.',
      demoRole: {
        admin: 'Admin',
        ceo: 'CEO',
        hr: 'HR',
        accountant: 'Accountant',
        supervisor: 'Supervisor',
        supervisee: 'Supervisee',
        contractor: 'Contractor',
        external: 'External',
      },
      demoHint: {
        admin: 'Every module and the Admin pages',
        ceo: 'Sign-offs and approvals',
        hr: 'People, leave and time admin',
        accountant: 'Sales, payroll and the activity fund',
        supervisor: 'Leads a team and approves its requests',
        supervisee: 'Their own time, leave and schedule',
        contractor: 'Only their own days and schedule',
        external: "An outside company's worker: only their own schedule and days",
      },
      methodPassword: 'Password',
      methodCode: 'Email me a code',
      methodGroup: 'Sign-in method',
      codeNeedsEmail: 'A code can only be sent to an email address.',
      sendCode: 'Send code',
      sending: 'Sending…',
      codeStepTitle: 'Enter the code',
      codeLabel: 'Code',
      verify: 'Sign in',
      verifying: 'Signing in…',
      changeEmail: 'Use a different email',
      forgotLink: 'Forgot your password?',
      forgotIntro: "A company's administrator resets their password with a code sent to their email. Everyone else, ask your administrator.",
      forgotSend: 'Email me a code',
      forgotSent: 'If this is an administrator who has signed in before, we emailed a code. It can take a minute to arrive.',
      forgotSave: 'Set new password',
      forgotSaving: 'Saving…',
      forgotDone: 'Your password is changed. Sign in with it now.',
      forgotBack: 'Back to sign in',
      secondStepNotice: 'We emailed you a sign-in code. Enter it here to finish signing in.',
      secondStepRefused: 'That code is not right or has expired. Try again, or start over for a new code.',
      secondStepNotSent: 'Your password was right, but we could not email the code. Try again in a few minutes.',
      secondStepTooMany: 'Too many codes were sent to this account. Wait an hour and try again.',
      startOver: 'Start over',
      adminSubtitle: 'Configure the email code sign-in policy.',
      settingsTitle: 'Advanced settings',
      enabled: 'Enable email code sign-in',
      codeLength: 'Code length',
      codeLengthHint: '4–12 digits',
      ttlSeconds: 'Code lifetime (seconds)',
      ttlHint: '60–3600 seconds',
      maxAttempts: 'Max attempts',
      maxAttemptsHint: '1–10 attempts',
      maxRequestsPerHour: 'Codes per hour',
      maxRequestsPerHourHint: '1–50 per email address',
      allowExternalEmail: 'Allow external email addresses',
      saved: 'Saved',
      loadFailed: 'Could not load the sign-in settings',
      noChanges: 'Nothing has changed yet',
      accountNotSetUp:
        "Your Microsoft account ({{address}}) isn't set up in CenTrig yet: ask HR or an admin to add it.",
      accountNotSetUpNoAddress:
        "Your Microsoft account isn't set up in CenTrig yet: ask HR or an admin to add it.",
    },
  },
  ru: {
    otp: {
      orDivider: 'или',
      signInPrompt: 'Войдите, чтобы продолжить.',
      signInMicrosoft: 'Войти через Microsoft',
      signInMicrosoftWaiting: 'Ожидание Microsoft…',
      signInMicrosoftHint: 'Используется ваша рабочая учётная запись — та же, что и в Teams.',
      noAccountTitle: 'Нет учётной записи CenTrig',
      noAccountSwitch: 'Войти под другим именем',
      noAccountFallback: 'Вход через Microsoft выполнен, но у этой учётной записи нет профиля в CenTrig, поэтому доступ закрыт. Попросите администратора добавить вас.',
      noAccountInactive: 'Эта учётная запись неактивна. Если это ошибка, обратитесь в отдел кадров или к администратору.',
      demoTitle: 'Войти как',
      demoIntro: 'Это демо с вымышленной компанией. Выберите роль, чтобы увидеть то, что видит этот человек.',
      demoCodeLabel: 'Код доступа к демо',
      demoSigningIn: 'Вход…',
      demoLoadFailed: 'Не удалось загрузить демо-пользователей',
      demoNone: 'В этом демо некем войти. Заполните его заново.',
      demoRole: {
        admin: 'Администратор',
        ceo: 'Генеральный директор',
        hr: 'Отдел кадров',
        accountant: 'Бухгалтер',
        supervisor: 'Руководитель',
        supervisee: 'Подчинённый',
        contractor: 'Подрядчик',
        external: 'Внешний работник',
      },
      demoHint: {
        admin: 'Все модули и страницы администратора',
        ceo: 'Утверждения и согласования',
        hr: 'Сотрудники, отпуска и учёт времени',
        accountant: 'Продажи, зарплата и фонд мероприятий',
        supervisor: 'Руководит командой и утверждает её заявки',
        supervisee: 'Своё время, отпуска и график',
        contractor: 'Только свои дни и график',
        external: 'Работник сторонней компании: только свой график и дни',
      },
      methodPassword: 'Пароль',
      methodCode: 'Код на email',
      methodGroup: 'Способ входа',
      codeNeedsEmail: 'Код можно отправить только на адрес email.',
      sendCode: 'Отправить код',
      sending: 'Отправка…',
      codeStepTitle: 'Введите код',
      codeLabel: 'Код',
      verify: 'Войти',
      verifying: 'Вход…',
      changeEmail: 'Использовать другой email',
      forgotLink: 'Забыли пароль?',
      forgotIntro: 'Администратор компании сбрасывает пароль с помощью кода, отправленного на его email. Остальным следует обратиться к администратору.',
      forgotSend: 'Отправить мне код',
      forgotSent: 'Если это администратор, который уже входил в систему, мы отправили код на email. Письмо может идти около минуты.',
      forgotSave: 'Задать новый пароль',
      forgotSaving: 'Сохранение…',
      forgotDone: 'Пароль изменён. Теперь войдите с новым паролем.',
      forgotBack: 'Вернуться ко входу',
      secondStepNotice: 'Мы отправили вам код для входа на email. Введите его здесь, чтобы завершить вход.',
      secondStepRefused: 'Код неверный или его срок истёк. Попробуйте ещё раз или начните заново, чтобы получить новый код.',
      secondStepNotSent: 'Пароль верный, но отправить код на email не удалось. Попробуйте ещё раз через несколько минут.',
      secondStepTooMany: 'На эту учётную запись отправлено слишком много кодов. Подождите час и попробуйте снова.',
      startOver: 'Начать заново',
      adminSubtitle: 'Настройте политику входа по коду на email.',
      settingsTitle: 'Дополнительные настройки',
      enabled: 'Включить вход по коду на email',
      codeLength: 'Длина кода',
      codeLengthHint: '4–12 символов',
      ttlSeconds: 'Срок действия кода (секунды)',
      ttlHint: '60–3600 секунд',
      maxAttempts: 'Максимум попыток',
      maxAttemptsHint: '1–10 попыток',
      maxRequestsPerHour: 'Кодов в час',
      maxRequestsPerHourHint: '1–50 на один email',
      allowExternalEmail: 'Разрешить внешние email-адреса',
      saved: 'Сохранено',
      loadFailed: 'Не удалось загрузить настройки входа',
      noChanges: 'Изменений нет',
      accountNotSetUp:
        'Ваша учётная запись Microsoft ({{address}}) ещё не настроена в CenTrig: попросите отдел кадров или администратора добавить её.',
      accountNotSetUpNoAddress:
        'Ваша учётная запись Microsoft ещё не настроена в CenTrig: попросите отдел кадров или администратора добавить её.',
    },
  },
}
